import { create } from 'zustand/index'
import { immer } from 'zustand/middleware/immer'

import { IUploadStore, IUploadStoreProps, UseUploadFileStore } from './types'

///---Current definition
const initialStore: IUploadStoreProps = {
  isLoading: false,
  uploadFiles: [],
}

export const useUploadStore = create<IUploadStore>((set, get) => ({
  ...initialStore,

  setIsLoading: isLoading => set({ isLoading }),
  addUploadFile: file => {
    set(state => {
      if (!state.uploadFiles.find(item => item.fileName === file.fileName))
        return { uploadFiles: [...state.uploadFiles].concat([file]) }
      return state
    })
  },

  removeUploadFile: fileName => {
    const indexFile = get().uploadFiles.findIndex(
      item => item.fileName === fileName,
    )
    set(state => {
      if (!isNaN(Number(indexFile))) {
        const uploadFiles = [...state.uploadFiles]
        uploadFiles.splice(indexFile, 1)
        return { uploadFiles }
      }
      return state
    })
  },
}))

///---Previous definition
export const useUploadStoreOLD = create<UseUploadFileStore>()(
  immer(set => ({
    isLoading: false,
    addTask: params => {
      const { marketplace, connection_id, ...rest } = params
      set(state => {
        state.taskList = {
          ...state.taskList,
          [marketplace]: {
            ...(state.taskList?.[marketplace] || {}),
            [connection_id]: rest,
          },
        }
      })
    },

    removeTask: params => {
      const { marketplace, connection_id } = params
      set(state => {
        state.taskList = {
          ...state.taskList,
          [marketplace]: {
            [connection_id]: null,
          },
        }
      })
    },

    updateTask: params => {
      const { marketplace, connection_id, updates } = params
      set(state => {
        const marketplaceTasks = state.taskList?.[marketplace]
        if (!marketplaceTasks) return

        const connectionTask = marketplaceTasks[connection_id]
        if (!connectionTask) return

        const updatedTasks = { ...connectionTask, ...updates }

        state.taskList = {
          ...state.taskList,
          [marketplace]: {
            ...marketplaceTasks,
            [connection_id]: updatedTasks,
          },
        }
      })
    },

    setIsLoading: loading =>
      set(state => {
        state.isLoading = loading
      }),

    setMarketplace: marketplace =>
      set(state => {
        state.marketplace = marketplace
      }),
  })),
)
